import './tags_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.PostTagsFilterView extends Monitoring.Views.SocialContents.Filters.TagsFilterView

  withPrefix: (search_query_field) ->
    "post_#{search_query_field}"
